import { ButtonWithArrow } from "components/base/base";
import Button from "components/base/Button";
import moment from "moment";
import ExtraComputeString from "pages/orderScheduler/ExtraComputeString";
import { isEmpty } from "pages/tools/utils";
import { Fragment, useState } from "react";
import {
  BsArrowRight,
  BsFillCalendar3WeekFill,
  BsInfoCircle,
} from "react-icons/bs";
import { IoIosCube } from "react-icons/io";
import { Link } from "react-router-dom";

const ProductionView = ({
  index,
  production,
  prevProductions,
  showProductionDates,
}) => {
  const [showPrevPos, setShowPrevPos] = useState(false);

  const category = production.category;

  console.log("production", production);

  return (
    <Fragment>
      <tr>
        <td
          colSpan={7}
          className={`p-2 bg-gray-100 dark:bg-gray-900 dark:bg-opacity-80`}
        >
          <div>
            <div className="flex items-center space-x-2">
              <div className="font-semibold">
                {index + 1}. {category.name} - {category.supplier.name}
              </div>
              {category.calendar && (
                <Link
                  className="flex-a"
                  to={`/supplier-calendar/?id=${category.calendar.id}`}
                  target="_blank"
                >
                  <BsFillCalendar3WeekFill className="" />
                </Link>
              )}
              <span>
                {category.time_string
                  ? `[
                       ${category.time_string}]`
                  : null}{" "}
                &times; {production.to_produce}
                {production.production_time < 0
                  ? " - Warning: Qty overflow!!"
                  : null}
              </span>
            </div>

            {category.extra_computings &&
            category.extra_computings.length > 0 ? (
              <div>
                <label className="pr-2">Extra Computings:</label>
                {category.extra_computings.map((i, extraIndex) => (
                  <span key={extraIndex} className="mr-2">
                    <span>
                      {i.name}({i.position}):{" "}
                    </span>
                    <span>
                      <ExtraComputeString type={i.type} value={i.value} />
                    </span>
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </td>
      </tr>

      {production.items.length === 0 ? (
        <tr>
          <td>No products in this node.</td>
        </tr>
      ) : (
        production.items.map((item, itemIndex) => (
          <tr
            key={itemIndex}
            className="border-y border-gray-50 dark:border-gray-800"
          >
            <td className="px-2 py-1">
              [{item.product.number}] {item.product.name}
            </td>
            <td className="text-right px-2 py-1">{item.qty}</td>
            <td className="text-right px-2 py-1 whitespace-nowrap">
              {item.delivery ? (
                <div className="flex justify-end space-x-2">
                  {item.delivery.type === "PO" ? (
                    <IoIosCube className="text-purple-600 text-base" />
                  ) : item.delivery.type === "SS" ? (
                    <IoIosCube className="text-orange-600 text-base" />
                  ) : (
                    "-"
                  )}
                  <span>{item.delivery.origin}</span>
                  <span>{moment(item.delivery.date).format("YYYY-MM-DD")}</span>
                  {item.delivery.type == "PO" ? (
                    <span>
                      {item.delivery.qty}({item.delivery.final_odoo_forecast})
                    </span>
                  ) : (
                    <span>
                      {item.delivery.qty}({item.delivery.final_ss_forecast})
                    </span>
                  )}
                </div>
              ) : (
                "-"
              )}
            </td>
            <td className="text-right px-2 py-1">
              {item.to_consume > 0 ? item.to_consume : "-"}
            </td>
            <td className="text-right px-2 py-1">{item.to_produce}</td>
          </tr>
        ))
      )}

      <tr>
        <td className="p-2 pb-4" colSpan={7}>
          <div className="flex items-baseline space-x-4">
            <div>
              <div
                className={`flex items-baseline space-x-2
                ${production.compute_production_time_error ? "text-red-600" : "text-teal-600"}
                `}
              >
                <div className="font-semibold text-base flex items-center space-x-2">
                  <span>
                    {moment(production.production_start_date).format(
                      "YYYY-MM-DD",
                    )}
                  </span>
                  <BsArrowRight />
                  <span>
                    {moment(production.ready_date).format("YYYY-MM-DD")}{" "}
                    {production.buffer_days > 0 &&
                      `(${moment(production.ready_date_before_buffer).format("YYYY-MM-DD")} + ${production.buffer_days} buffer days)`}
                  </span>
                </div>
              </div>

              {production.compute_production_time_error && (
                <div className="text-red-600 mb-2 font-semibold">
                  ⚠️ {production.compute_production_time_error}
                </div>
              )}

              {production.to_produce > 0 ? (
                <div className="flex items-center space-x-2">
                  <div className="space-x-2 opacity-50">
                    {production.before_production_days > 0 && (
                      <span>
                        Before Production: {production.before_production_days}{" "}
                        days
                      </span>
                    )}

                    <span>
                      Production Time: {production.production_days} days
                    </span>

                    {production.after_production_days > 0 && (
                      <span>
                        After Production: {production.after_production_days}{" "}
                        days
                      </span>
                    )}

                    {production.days_to_transfer > 0 ? (
                      <>
                        <span>+</span>
                        <span>
                          Transfer: {production.days_to_transfer} days
                        </span>
                      </>
                    ) : null}
                  </div>
                  {!isEmpty(production.production_dates_with_qty) && (
                    <Button onClick={() => showProductionDates(production)}>
                      <BsInfoCircle />
                    </Button>
                  )}
                </div>
              ) : null}

              {prevProductions.length > 0 && (
                <div className="opacity-50 text-[10px]">
                  <div>Prev Productions</div>
                  <div className="-mx-2">
                    <table>
                      <tbody>
                        {prevProductions.map((p, pIndex) => (
                          <tr key={pIndex}>
                            <td className="font-code whitespace-nowrap py-0 align-baseline">
                              {moment(p.ready_date).format("YYYY-MM-DD")}
                            </td>
                            <td className="w-full py-0 pl-0">
                              <div className=" font-semibold">
                                {p.category.name}
                              </div>
                              <div className="space-x-2 text-[8px]">
                                {p.items.map((i, iIndex) => (
                                  <span key={iIndex}>
                                    [{i.product.number}] &times; {i.qty}
                                  </span>
                                ))}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {production.prev_pos ? (
              <ButtonWithArrow
                className="text-sky-600"
                show={showPrevPos}
                onClick={() => setShowPrevPos((prev) => !prev)}
              >
                {showPrevPos ? "Hide" : "Show"} Current Production
              </ButtonWithArrow>
            ) : null}
          </div>
        </td>
      </tr>

      {showPrevPos ? (
        <tr>
          <td colSpan={6}>
            <div className="flex">
              <div className="bg-gray-100 dark:bg-gray-900 dark:bg-opacity-50 rounded-2xl p-4 mb-4">
                <div className="px-2">
                  Total qty in PO not confirmed for this production category by
                  month.
                </div>
                <div className="flex">
                  <div className="mt-2">
                    {production.prev_pos.map((po) => (
                      <div
                        key={po.id}
                        className="text-xs opacity-70 flex items-center justify-between border-b dark:border-gray-700 space-x-8"
                      >
                        <div className="px-2 py-1 ">
                          {po.year} - {po.month}
                        </div>

                        <div className="px-2 py-1">{po.assignedQty}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      ) : null}
    </Fragment>
  );
};

export default ProductionView;
